var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.buttonClass,on:{"click":function () {
  _vm.scrollToElement();
  _vm.sendYmTarget();
  _vm.$emit('click');
}}},[(_vm.nameImage)?_c('svg',{class:_vm.svgClass,attrs:{"width":"25px","height":"30px"}},[_c('use',{attrs:{"xlink:href":_vm.svgHref}})]):_vm._e(),(_vm.title)?_c('p',{staticClass:"function-button__text"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }